module.exports = __webpack_public_path__ + "static/media/fitglobal.349fcc41.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/fitglobal.webp
// module id = 646
// module chunks = 0